<div class="available-modal">
  <div class="header d-flex flex-column align-items-center justify-content-center">
    <h4>Available MAPS</h4>
    <div class="on-second">
      <ng-select class="wt-select" [(ngModel)]="selectedMap_id" [items]="mapList"
        bindValue="map_id" bindLabel="map_name" placeholder="Select a map" [clearable]="true" appendTo="body">
        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select a map' }}</span></ng-template>
        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.map_name }}</span></ng-template>
      </ng-select>
    </div>
    <button class="close-button" (click)="closeModal()" >
      <img src="assets/icons/icon-close.svg" alt="Close" />
    </button>
  </div>
  <div class="wrapper d-flex align-items-center justify-content-center w-100">
    <button class="btn btn-theme" [disabled]="!selectedMap_id" (click)="selectMap()">
      Select map
    </button>
  </div>
</div>